import { render, staticRenderFns } from "./CphPagination.vue?vue&type=template&id=1d9124b4&scoped=true&"
import script from "./CphPagination.vue?vue&type=script&lang=js&"
export * from "./CphPagination.vue?vue&type=script&lang=js&"
import style0 from "./CphPagination.vue?vue&type=style&index=0&id=1d9124b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9124b4",
  null
  
)

export default component.exports